import { render, staticRenderFns } from "./CodeHighlight.vue?vue&type=template&id=3b8cee1a"
import script from "./CodeHighlight.vue?vue&type=script&lang=js"
export * from "./CodeHighlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports